import PropTypes from 'prop-types';
import React from "react";
import Relay from "react-relay"
import { dispatch } from "../../Dispatcher"
import SearchDisplayTools from "./SearchDisplayTools"
import SetsBreadcrumb from "../elements/SetsBreadcrumb"
import SetResources from "./SetResources"
import State from "../../stores/State"
import { setArticleStyle } from "../../actions"
import { width } from "../../scripts/size"
import { SET_ARTICLE_STYLES, MOBILE_ARTICLE_STYLE_ID } from "../../constants"
import { getStyles } from '../../styles/dynamicStyles';

class UserSet extends React.Component {
  state = {
    articleStyle: State.get("articleStyle"),
    articleStyles: SET_ARTICLE_STYLES
  }

  componentDidMount() {
    this.handleArticleStyles()
    this._stateListener = State.addListener(() => {
      const articleStyle = State.get("articleStyle")
      if (articleStyle !== this.state.articleStyle) {
        this.setState({ articleStyle })
      }
    })
    window.addEventListener("resize", this.handleArticleStyles)
  };

  componentWillUnmount() {
    if (this._stateListener) {
      this._stateListener.remove()
    }
    window.removeEventListener("resize", this.handleArticleStyles)
  }

  handleArticleStyles = () => {
    if (width() <= 512) {
      this.setState({ articleStyle: MOBILE_ARTICLE_STYLE_ID })
      dispatch(setArticleStyle(MOBILE_ARTICLE_STYLE_ID))
    }
  }

  render() {
    const { viewer, userSet } = this.props

    return (
      <div>
        <div className="search-results__tools">
          <div className="column row">
            <div className="search-results__tools-inner">
              <div className="c-results-panel search-results__panel" style={getStyles('c-results-panel')}>
                <SearchDisplayTools articleStyles={this.state.articleStyles} withSort={false} />
                <SetsBreadcrumb viewer={viewer} singleSetTitle={userSet.name} />
              </div>
            </div>
          </div>
        </div>
        <div className="column row">
          <SetResources userSet={userSet} articleStyle={this.state.articleStyle}/>
        </div>
      </div>
    )
  }
}

UserSet.propTypes = {
  viewer: PropTypes.object.isRequired
}

export default Relay.createContainer(UserSet, {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        ${SetsBreadcrumb.getFragment("viewer")}
      }
    `,
    userSet: () => Relay.QL`
      fragment on UserSet {
        name
        ${SetResources.getFragment("userSet")}
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/UserSet.js